import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useStore } from '../../shared/contexts/StoreContext';

const Container = styled.div`
  max-width: 450px;
  margin: 0 auto;
  padding: 40px 20px;
  text-align: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #f9fafb;
`;

const IconWrapper = styled.div<{ success?: boolean }>`
  font-size: 80px;
  color: ${props => props.success ? '#22c55e' : '#ef4444'};
  margin-bottom: 24px;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 900;
  color: #111;
  margin-bottom: 16px;
  text-transform: uppercase;
`;

const Message = styled.p`
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 32px;
`;

const Button = styled.button<{ secondary?: boolean }>`
  width: 100%;
  padding: 20px;
  border-radius: 1.25rem;
  font-weight: 900;
  font-size: 18px;
  border: none;
  background: ${props => props.secondary ? '#f3f4f6' : '#22c55e'};
  color: ${props => props.secondary ? '#666' : 'white'};
  margin-bottom: 12px;
  cursor: pointer;
  transition: transform 0.2s;
  
  &:active {
    transform: scale(0.98);
  }
`;

export const OrderResultPage: React.FC<{ type: 'success' | 'failure' | 'pending' }> = ({ type }) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { store } = useStore();
    const orderId = searchParams.get('orderId');

    const handleWhatsApp = () => {
        // O ideal é que o cliente já tenha enviado o whats, 
        // mas aqui é um fallback de segurança.
        navigate('/');
    };

    const content = {
        success: {
            icon: 'fa-check-circle',
            title: 'PAGAMENTO APROVADO!',
            message: 'Seu pagamento foi confirmado com sucesso. A cozinha já foi notificada e seu pedido entrará em preparo em instantes.'
        },
        failure: {
            icon: 'fa-times-circle',
            title: 'PAGAMENTO RECUSADO',
            message: 'Infelizmente não conseguimos processar seu pagamento. Verifique os dados do cartão ou tente outra forma de pagamento.'
        },
        pending: {
            icon: 'fa-clock',
            title: 'PAGAMENTO EM ANÁLISE',
            message: 'Seu pagamento está sendo processado pelo Mercado Pago. Assim que for aprovado, seu pedido será liberado.'
        }
    };

    const current = content[type];

    return (
        <Container>
            <IconWrapper success={type === 'success'}>
                <i className={`fas ${current.icon}`}></i>
            </IconWrapper>
            <Title>{current.title}</Title>
            <Message>{current.message}</Message>
            
            <Button onClick={() => navigate('/')}>
                VOLTAR AO CARDÁPIO
            </Button>
            
            <p style={{ marginTop: '20px', fontSize: '14px', color: '#9ca3af' }}>
                ID do Pedido: {orderId}
            </p>
        </Container>
    );
};
